import { Injectable } from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {Asset, AssetStatus} from '../../models/asset.model';

@Injectable()
export class AssetService extends Subject<Asset> {
  public subscription: Subscription;

  public publish(type:string, asset: any, options?:any) {
    super.next( new Asset(AssetStatus.publish, type, asset, options ) );
    console.log("Published asset: " + JSON.stringify(asset, null,4));
  }

  public unpublish(type:string, asset: any) {
    super.next( new Asset(AssetStatus.unpublish, type, asset) );
  }
}
